import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './pos-device-listing.component.scss';
var PosDeviceListing = /** @class */ (function (_super) {
    tslib_1.__extends(PosDeviceListing, _super);
    function PosDeviceListing(element) {
        return _super.call(this, element) || this;
    }
    PosDeviceListing.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.clearFilterbutton = this.element.querySelector('.js-clear-filters');
        this.checkboxes = Array.from(this.element.querySelectorAll('input[type=checkbox]'));
        this.checkboxesLabel = this.element.querySelector('.js-checkbox-multiple-only');
    };
    PosDeviceListing.prototype.bindEvents = function () {
        var _this = this;
        this.clearFilterbutton.addEventListener("click", function (e) {
            _this.form.reset();
            _this.checkboxesLabel.innerHTML = "Please select";
        });
    };
    return PosDeviceListing;
}(Base));
export { PosDeviceListing };



//////////////////
// WEBPACK FOOTER
// ./components/pos-device-listing/pos-device-listing.component.ts
// module id = 631
// module chunks = 0